import React from "react";
import { Stack } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { Roles, RolesValues } from "../../app/features/auth/authTypes";
import { tokenLogin } from "../../app/features/auth/authActions";
import { toggleDeveloperView } from "../../app/features/auth/authSlice";

const toggleSx = { color: "white", backgroundColor: "#FFFFFF99" };
// The developer switch stands alone, so it takes only the light background: a white text set on the
// button itself, rather than on a group around it, would vanish on that background once switched
// off. It then reads like the role buttons, dark when off and blue when on.
const developerSx = { backgroundColor: "#FFFFFF99" };

// An admin sees the app as any role would; one who is a developer can also switch the pages in soft
// launch off and on, to see the app with and without them.
const RoleSwitcher = () => {
  const activeRole = useAppSelector((state) => state.auth.role);
  const originalRole = useAppSelector((state) => state.auth.mainRole);
  const isDeveloper = useAppSelector((state) => state.auth.isDeveloper);
  const mainIsDeveloper = useAppSelector((state) => state.auth.mainIsDeveloper);
  const dispatch = useAppDispatch();
  const token = useAppSelector((state) => state.auth.token);

  if (originalRole !== "Admin" || !token) {
    return null;
  }

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    value: string,
  ) => {
    dispatch(tokenLogin(token, value as Roles));
  };

  return (
    <Stack direction="row" spacing={1}>
      <ToggleButtonGroup
        color="primary"
        sx={toggleSx}
        size="small"
        exclusive
        value={activeRole}
        onChange={handleChange}
      >
        {RolesValues.map((role: string) => (
          <ToggleButton key={role} value={role as Roles}>
            {role}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {mainIsDeveloper && (
        <ToggleButton
          color="primary"
          sx={developerSx}
          size="small"
          value="developer"
          selected={isDeveloper}
          onChange={() => dispatch(toggleDeveloperView())}
        >
          Developer
        </ToggleButton>
      )}
    </Stack>
  );
};

export default RoleSwitcher;
